const state = {
    userInfo: null, // 用户信息
    labelList: [], // 页签数据
    menuList: [],
    openKeys: [], // 展开菜单
    selectedKeys: [], // 选中菜单
    addressList: [], // 地址信息
    orderInfo: [],
    hasQuickOrder: null,
    DispatchList: [], // 置顶派车统计
    isLoggedIn: false,
}

export default state